import damascus_university from "../assets/logos/damascus_university.jpeg";
import hyf from "../assets/logos/hyf.jpeg";
import unrwa from "../assets/logos/unrwa.jpeg";

const education = {
  english: [
    {
      title: "Web development",
      grade: "Full-Stack developer",
      school: "Hack Your Future",
      from: "Mar 2022",
      until: "Nov 2022",
      location: "Amsterdam - The Netherlands",
      logo: hyf,
      keys: ["programming", "presentation", "planning", "analyzing"],
    },
    {
      title: "Education - Teaching",
      grade: "Diploma - 1 year after the university",
      school: "UNRWA-UNESCO institute",
      from: "Sep 2011",
      until: "Aug 2012",
      location: "Damascus - Syria",
      logo: unrwa,
      keys: ["presentation", "teaching", "research", "analyzing"],
    },
    {
      title: "Radiation Protection and Safety of Radiation Sources",
      grade: "Master - 1 year certificate",
      school: "Damascus University & AECS & IAEA",
      from: "Sep 2008",
      until: "Sep 2010",
      location: "Damascus - Syria",
      logo: damascus_university,
      keys: [
        "experimentation",
        "physics",
        "protection",
        "presentation",
        "research",
        "safety",
        "analyzing",
      ],
    },
    {
      title: "Science - Physics",
      grade: "Bachelor",
      school: "Damascus University",
      from: "Sep 2002",
      until: "Jun 2007",
      location: "Damascus - Syria",
      logo: damascus_university,
      keys: [
        "experimentation",
        "physics",
        "presentation",
        "research",
        "analyzing",
      ],
    },
  ],
  arabic: [
    {
      title: "برمجة وتطوير تطبيقات الويب",
      grade: " الدرجة: مطور الواجهتين الأمامية والخلفية",
      school: "Hack Your Future",
      from: "Mar 2022",
      until: "Nov 2022",
      location: "أمستردام - هولندا",
      logo: hyf,
      keys: ["programming", "presentation", "planning", "analyzing"],
    },
    {
      title: "طرائق وتقنيات التدريس",
      grade: "الدرجة: دبلوم لمدة سنة واحدة بعد الجامعة",
      school: "معهد الانروا - اليونيسكو",
      from: "Sep 2011",
      until: "Aug 2012",
      location: "دمشق - سوريا",
      logo: unrwa,
      keys: ["presentation", "teaching", "research", "analyzing"],
    },
    {
      title: "الوقاية الإشعاعية و أمان مصادر الإشعاع و أمنها",
      grade: "الدرجة: ماجستير - شهادة السنة الدراسية الأولى",
      school: "Damascus University & AECS & IAEA",
      from: "Sep 2008",
      until: "Sep 2010",
      location: "دمشق - سوريا",
      logo: damascus_university,
      keys: [
        "experimentation",
        "physics",
        "protection",
        "presentation",
        "research",
        "safety",
        "analyzing",
      ],
    },
    {
      title: "العلوم الفيزيائية",
      grade: "الدرجة: بكالوريوس",
      school: "جامعة دمشق",
      from: "Sep 2002",
      until: "Jun 2007",
      location: "دمشق - سوريا",
      logo: damascus_university,
      keys: [
        "experimentation",
        "physics",
        "presentation",
        "research",
        "analyzing",
      ],
    },
  ],
};

export default education;
